(function() {
  "use strict";

  angular
    .module("admin.coinproduct.service", [])
    .factory("CoinProductService", CoinProductService);

  /** @ngInject */
  function CoinProductService($http, $q, API) {
    function list() {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/products/coins")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listTranslations(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/products/" + id + "/product_translations")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listInactive(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/products/coins/unpublished?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listInactiveBy(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/products/coins/unpublished?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listActive(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/products/coins/published?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listActiveBy(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/products/coins/published?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listArchived(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/products/coins/archived?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listArchivedBy(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/products/coins/archived?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function get(id) {
      var defered = $q.defer();

      $http.get(API.API_URL + "admin/products/" + id).success(defered.resolve);

      return defered.promise;
    }

    function getTranslation(id) {
      var defered = $q.defer();

      $http.get(API.API_URL + "admin/product_translations/" + id).success(defered.resolve);

      return defered.promise;
    }

    function save(model) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/products", model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function saveTranslation(id, model) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/products/" + id + "/product_translations?automatic=true", model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function update(id, model) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "admin/products/" + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function updateTranslation(id, model) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "admin/product_translations/" + id + '?automatic=true', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function remove(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/products/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeTranslation(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/product_translations/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function publish(id) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/products/" + id + "/publish")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function unpublish(id) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/products/" + id + "/unpublish")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function archive(id) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/products/" + id + "/archive")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listProductSegmentation(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/products/" + id + "/user_segments")
        .success(defered.resolve);

      return defered.promise;
    }

    function listSegmentation() {
      var defered = $q.defer();

      $http.get(API.API_URL + "admin/user_segments").success(defered.resolve);

      return defered.promise;
    }

    function addProductSegmentation(id, segmentId) {
      var defered = $q.defer();

      $http
        .post(
          API.API_URL + "admin/products/" + id + "/user_segments/" + segmentId
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeProductSegmentation(id, segmentId) {
      var defered = $q.defer();

      $http
        .delete(
          API.API_URL + "admin/products/" + id + "/user_segments/" + segmentId
        )
        .success(defered.resolve);

      return defered.promise;
    }

    return {
	list: list,
	listInactive: listInactive,
	listInactiveBy: listInactiveBy,
	listActive: listActive,
	listActiveBy: listActiveBy,
	listArchived: listArchived,
	listArchivedBy: listArchivedBy,
	listTranslations: listTranslations,
	get: get,
	getTranslation: getTranslation,
	save: save,
	saveTranslation: saveTranslation,
	update: update,
	updateTranslation: updateTranslation,
	remove: remove,
	publish: publish,
	unpublish: unpublish,
	archive: archive,
	listProductSegmentation: listProductSegmentation,
	listSegmentation: listSegmentation,
	addProductSegmentation: addProductSegmentation,
	removeProductSegmentation: removeProductSegmentation,
	removeTranslation: removeTranslation,
    };
  }
})();
